import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Clock, Mail, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 text-zinc-400">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Sauce Sity Barbershop</h3>
            <p className="text-sm">
              Where style meets precision. Premium grooming services in Cape Coral.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/services" className="hover:text-lime-400 transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/booking" className="hover:text-lime-400 transition-colors">
                  Book Appointment
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="hover:text-lime-400 transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-lime-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="hover:text-lime-400 transition-colors">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>2401 Hancock Bridge Pkwy Unit 2, Cape Coral, FL 33990</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <a href="tel:2392018105" className="hover:text-lime-400 transition-colors">
                  (239) 201-8105
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:Saucesity2020@gmail.com" className="hover:text-lime-400 transition-colors">
                  Saucesity2020@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <div>Tue - Sat: 8:30 AM - 6:00 PM</div>
                  <div className="text-zinc-500">Closed Sun & Mon</div>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Follow Us</h4>
            <div className="flex flex-col space-y-3 text-sm">
              <a 
                href="https://www.instagram.com/sauce_kidd20" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 hover:text-lime-400 transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span>@sauce_kidd20</span>
              </a>
              <a 
                href="https://www.instagram.com/sauce_sity_barbershop" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 hover:text-lime-400 transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span>@sauce_sity_barbershop</span>
              </a>
            </div>
            <div className="mt-6">
              <a
                href="https://www.google.com/maps/place/2401+Hancock+Bridge+Pkwy+Unit+2,+Cape+Coral,+FL+33990"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-lime-400 hover:text-lime-300"
              >
                Get Directions →
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; 2024 Sauce Sity Barbershop. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
